var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-tree", {
        ref: "tree",
        staticClass: "content",
        attrs: {
          data: _vm.rbacTree,
          "show-checkbox": "",
          "node-key": "actionId",
          "default-expand-all": "",
          "expand-on-click-node": false,
          "check-on-click-node": true,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "span",
                {
                  class: [
                    {
                      foo: node.level === 4,
                    },
                    { first: node.level === 1 },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.test(node)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(data.actionName) + " ")]
              )
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticStyle: { "text-align": "end", "margin-top": "10px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "90px" },
              attrs: {
                loading: _vm.sumbitLoading,
                type: "primary",
                size: "small",
              },
              on: { click: _vm.sumbit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }